
export function columns () {
  return [{
    id: 1, title: 'Name', field: 'name', filter: '', filterLabel: 'Filter By Name'
  }, {
    id: 2, title: 'Tenant Id', field: 'id', filter: '', filterLabel: 'Filter By Tenant Id'
  }, {
    id: 3, title: 'Tenant Status', field: 'status', filter: 'all', filterType: 'select', filterMinWidth: 85,
    options: [{ label: 'All', value: 'all' }, { label: 'Active', value: 'Active' }, { label: 'Suspended', value: 'Suspended' }]
  }, {
    id: 4, title: 'SPTS Status', field: 'sptsStatus', filter: 'all', filterType: 'select', filterMinWidth: 75,
    options: [{ label: 'All', value: 'all' }, { label: 'Enabled', value: 'Enabled' }, { label: 'Disabled', value: 'Disabled' }]
  }, {
    id: 5, title: 'Proxy Status', field: 'proxyStatus', filter: 'all', filterType: 'select', filterMinWidth: 75,
    options: [{ label: 'All', value: 'all' }, { label: 'Enabled', value: 'Enabled' }, { label: 'Disabled', value: 'Disabled' }]
  },{
    id: 6, title: 'One2M Status', field: 'one2mStatus', filter: 'all', filterType: 'select', filterMinWidth: 75,
    options: [{ label: 'All', value: 'all' }, { label: 'Enabled', value: 'Enabled' }, { label: 'Disabled', value: 'Disabled' }]
  },{
    id: 7, title: 'Created Date', field: 'created_ts', filter: '', isDate: true
  }];
}
